import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import { findListener } from "../plugin-notify-common/util";


export default class ResButtonUI extends Plugin {

    init() {
        const editor = this.editor;
        const command = editor.commands.get('responseButton');
        editor.ui.componentFactory.add('responseButton', (locale) => {
            const view = new ButtonView(locale);
            view.set({
                label: '变量',
                withText: false,
                tooltip: true,
                icon: '<svg t="1692848652943" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="165905" width="24" height="24"><path d="M76.827494 981.504c-19.968-1.024-39.424-5.632-57.856-12.8-12.8-11.264-19.456-27.648-18.944-44.032 1.024-14.848 7.68-28.672 19.456-37.888 11.776-7.168 24.576-11.264 38.4-12.8h32.256c18.944 0 38.4 6.144 64 6.144 17.92 2.56 36.352-2.048 51.2-12.8 18.432-29.184 31.232-61.44 38.4-95.232L332.827494 410.624H224.283494l19.456-69.632H358.427494V327.68c7.168-53.76 24.576-104.96 51.2-152.064 24.064-40.96 59.904-74.24 102.4-95.232 38.4-19.456 79.36-32.256 121.856-37.888 17.92 0.512 35.328 4.608 51.2 12.8 12.8 11.264 19.456 27.648 19.456 44.544-1.536 13.312-5.632 26.624-12.8 37.888-11.776 7.168-24.576 11.264-38.4 12.8-22.016-1.024-43.52-5.632-64-12.8-12.8 0-19.456-6.144-32.256-6.144-18.944 3.584-35.328 15.36-45.056 31.744-13.312 30.72-24.064 62.464-32.256 95.232l-25.6 82.432 275.456-6.144h6.656c14.848 1.024 28.672 7.68 38.4 18.944 7.68 16.384 13.824 33.28 19.456 50.688l6.656 25.6 19.456-25.6c17.92-24.064 39.424-45.568 64-63.488 24.576-18.944 52.736-32.256 83.456-37.888 13.824 1.536 26.624 5.632 38.4 12.8 17.408 15.36 19.456 41.984 4.096 59.392-1.024 1.536-2.56 2.56-4.096 4.096l-6.656 6.144c-6.656 6.144-19.456 12.8-57.856 12.8-18.944-0.512-37.376 6.144-51.2 18.944-26.624 24.576-50.688 52.224-70.656 82.432v12.8l25.6 133.12c12.8 50.688 45.056 101.376 64 101.376s19.456-12.8 25.6-18.944V721.92c8.192-18.944 25.088-32.768 45.056-37.888 12.8 0 19.456 6.144 32.256 12.8 8.192 8.704 12.8 19.968 12.8 31.744 0 23.552-12.288 45.056-32.256 57.344-18.944 17.408-44.544 26.624-70.656 25.6-37.376 0-73.728-13.824-102.4-37.888-31.744-36.864-55.808-80.384-70.656-126.976l-6.656-25.6-19.456 18.944c-24.064 36.352-52.224 70.656-82.944 101.376-18.944 17.408-44.544 26.624-70.656 25.6-16.896 0.512-33.28-6.656-45.056-18.944-11.264-9.728-18.432-23.04-19.456-37.888-1.536-13.824 3.072-28.16 12.8-37.888 6.656-12.8 19.456-12.8 32.256-12.8 15.36-0.512 29.696 6.656 38.4 18.944l6.656 12.8 12.8-6.144 19.456-18.944c16.896-15.36 31.744-32.256 44.544-50.688l57.856-82.432-25.6-120.32-256-6.144-70.656 285.184c-19.456 79.36-56.32 153.088-109.056 215.552-53.248 44.032-120.832 71.168-191.488 74.24z" p-id="165906"></path></svg>'
            });
            // console.log(Template);
            //  将按钮的状态关联到命令对应值上
            view.bind("isOn", "isEnabled").to(command, "value", "isEnabled");
            // // 点击按钮时触发相应命令
            this.listenTo(view, "execute", () => {
                const listeners = editor.config.get('askPluginListener');
                console.debug('ed askPluginListener', listeners);
                let beforeButtonInsert = findListener(listeners, "BUTTON");
                beforeButtonInsert.process({ "type": "response"}, response => {
                    editor.execute('responseButton', response)
                });
            });
            return view;

        })

        // const editor = this.editor;
        // const t = editor.t;

        // editor.ui.componentFactory.add('responseButton', locale => {

        //     const command = editor.commands.get('responseButton');

        //     const buttonView = new ButtonView(locale);

        //     buttonView.set({
        //         label: t('插入快捷回复'),
        //         withText: true,
        //         tooltip: true,
        //         class:"cipher",
        //         icon:`<svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
        //                 x="0px" y="0px" viewBox="0 0 200 200" style="enable-background:new 0 0 200 200;" xml:space="preserve">
        //                 <style type="text/css">
        //                 .st0{fill:#D2D8E3;}
        //                 </style>
        //                 <g>
        //                     <path class="st0" d="M154.3,0H46.1C28.4,0,14,14.2,14,31.7v136.6c0,17.5,14.4,31.7,32,31.7h108.2c8.7,0,16.8-3.4,22.8-9.5
        //                     c5.9-6,9.1-14.1,8.9-22.5V31.7C186,14.2,171.7,0,154.3,0z M169.4,31.5V168c0,8.4-7.1,15.5-15.5,15.5H45.7
        //                     c-8.4,0-15.5-7.1-15.5-15.5V31.7c0-8.5,7.1-15.5,15.8-15.5h108.2c4.4,0,8.5,1.8,11.4,4.8C168.3,23.9,169.7,27.6,169.4,31.5z"/>
        //                     <path class="st0" d="M100,100.8c-4.2,0-6.9,2.8-6.9,7.1v13.4c0,4.3,2.7,7.1,6.9,7.1s6.9-2.8,6.9-7.1v-13.4
        //                     C106.9,103.6,104.2,100.8,100,100.8z"/>
        //                     <path class="st0" d="M131.3,75.9v-6.2c0-12.6-9.3-22.8-20.7-22.8h-20c-11.4,0-20.7,10.2-20.7,22.8v6C59.8,77,52,86.4,52,97.7v33.2
        //                     c0,12.2,9,22.2,20.2,22.2h55.6c11.1,0,20.2-9.9,20.2-22.2V97.7C148,86.8,140.7,77.7,131.3,75.9z M85.7,69.5
        //                     c0.1-3.1,2.3-5.6,4.8-5.6h19.9h0.2c2.6,0.1,4.7,2.7,4.7,5.8v5.8H85.7v-5.8V69.5z M132.6,131c0,3.2-2.2,5.7-4.8,5.7l0,0H72.2
        //                     c-2.6,0-4.8-2.7-4.8-5.8V97.6c0-3.2,2.2-5.7,4.8-5.7l0,0h55.7c2.6,0.1,4.7,2.7,4.7,5.8L132.6,131L132.6,131z"/>
        //                 </g>
        //             </svg>`,
        //     });

        //     buttonView.bind('isOn', 'isEnabled').to(command, 'value', 'isEnabled');

        //     this.listenTo(buttonView, 'execute', () => {
        //             // let position = editor.data.model.document.selection.anchor;
        //             // let contextElement = findLoopParent(position);
        //             // let model = {};
        //             // if (contextElement != null) {
        //             //     let scope = contextElement.getAttribute('scope');
        //             //     model.webhook_id = scope.slice(0, scope.indexOf('.'));
        //             //     model.list_key = scope.slice(scope.indexOf('.') + 1, scope.length);
        //             // }
        //             const listeners = editor.config.get('askPluginListener');
        //             let beforeButtonInsert = findListener(listeners, "BUTTON");
        //             beforeButtonInsert.process({"type": "BUTTON",param:{model:''}}, response => {
        //                 editor.execute('responseButton', response)
        //             });
        //         }
        //     );
        //     return buttonView;

        // });
    }

}
